import request from '../../utils/requests'
/** * Tag: Privilege */
const baseUrl ="/api/Privilege";

/** * 获取当前机构的角色列表 */async function _getOrgRoleList() {  return request(baseUrl+'/getOrgRoleList',{    method: 'GET',  });
}

/** * 获取角色权限 新增的时候roleId传0 * @param {*} param * { *    roleId Desc:角色id Required:true * } */async function _getOrgPrivilegeList(param) {  return request(baseUrl+'/getOrgPrivilegeList',{    method: 'GET',    params: param,  });
}

/** * 保存角色 * @param {*} body * { *    RoleId Desc:角色主键 Required:false *    RoleName Desc:角色名称 Required:false *    Description Desc: Required:false *    MenuId Desc:角色关联的菜单 Required:false * } */async function _orgRoleSave(body) {  return request(baseUrl+'/orgRoleSave',{    method: 'POST',    body: body,  });
}

/** * 删除角色及角色下员工 * @param {*} param * { *    orgRoleId Desc:角色ID Required:true * } */async function _delete(param) {  return request(baseUrl+'/delete',{    method: 'POST',    params: param,  });
}

/** * 获取指定角色校区员工 * @param {*} body * { *    BranchId Desc:校区ID Required:false *    RoleId Desc:角色ID Required:false *    NameOrPhone Desc:姓名或手机号 Required:false *    IsRole Desc:是否为该角色：1：是，0：否,全部：-1 Required:false *    Start Desc:开始行数 从0开始 Required:false *    Length Desc:页面大小 Required:false *    End Desc:结束行数 Required:false * } */async function _getOrgUserRolePaging(body) {  return request(baseUrl+'/getOrgUserRolePaging',{    method: 'POST',    body: body,  });
}

/** * 为角色批量添加员工 * @param {*} body * { *    UserIdList Desc:员工IdList Required:false *    RoleId Desc:角色ID Required:false * } */async function _batchAddOrgUserRole(body) {  return request(baseUrl+'/batchAddOrgUserRole',{    method: 'POST',    body: body,  });
}

/** * 批量删除权限内员工 * @param {*} body * { *    UserIdList Desc:员工IdList Required:false *    RoleId Desc:角色ID Required:false * } */async function _batchDelete(body) {  return request(baseUrl+'/batchDelete',{    method: 'POST',    body: body,  });
}

/** * 获取角色 * @param {*} param * { *    roleid Desc: Required:true * } */async function _getRoleById(param) {  return request(baseUrl+'/getRoleById',{    method: 'GET',    params: param,  });
}

export default{  _getOrgRoleList,  _getOrgPrivilegeList,  _orgRoleSave,  _delete,  _getOrgUserRolePaging,  _batchAddOrgUserRole,  _batchDelete,  _getRoleById}



// WEBPACK FOOTER //
// ./src/services/privilege.js